// Brand Core
export const myVJBlue300 = "#103c9e";
export const myVJBlue200 = "#2c47f1";
export const myVJBlue100 = "#427dff";
export const myVJWhite = "#ffffff";
export const myVJBlack900 = "#11192b";

// Brand Core Tints
export const myVJBlack950 = "#111928"; // Level 1 color for mobile
export const myVJBlack800 = "#333947";
export const myVJBlack750 = "#4a5568";
export const myVJBlack700 = "#3f4759";
export const myVJBlack600 = "#535d75";
export const myVJBlack500 = "#717d9b";
export const myVJBlack400 = "#8695ba";
export const myVJBlack200 = "#c6d4f8";
export const myVJBlack100 = "#e2eeff";
export const myVJBlack50 = "#f4f9ff";

// Brand Accents
export const myVJGreen200 = "#9fd520";
export const myVJGreen100 = "#bde75b";
export const myVJGreen50 = "#bde75b";
export const myVJGrey200 = "#d3d3d3";
export const myVJGrey100 = "#e2e2e2";
export const myVJGrey50 = "#f1f1f1";
export const myVJYellow200 = "#ffb909";
export const myVJYellow100 = "#ffe607";
export const myVJYellow50 = "#fffaca";
export const myVJOrange200 = "#e94f3d";
export const myVJOrange100 = "#fe7651";
export const myVJOrange50 = "#ffedd5";
export const myVJPurple200 = "#a06fd3";
export const myVJPurple100 = "#6e31ef";
export const myVJPurple50 = "#e1c6ff";

// Brand Semantics
export const myVJRed100 = "#e02424";
export const myVJRed50 = "#fde8e8";
export const myVJSuccess100 = "#00760c";
export const myVJSuccess50 = "#def7ec";
export const myVJDisabled100 = "#a1a1a1";
export const myVJDisabled50 = "#c3c3c3";
export const myVJReadOnly50 = "#f8f8f8";

